import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowGroupCommands } from '../constant';
import { XFLOW_GROUP_DEFAULT_COLLAPSED_SIZE } from '../../constants';
export var NsInitGroup;
(function (NsInitGroup) {
    /** Command: 用于注册named factory */
    NsInitGroup.command = XFlowGroupCommands.INIT_GROUP;
    /** hookName */
    NsInitGroup.hookKey = 'initGroup';
})(NsInitGroup || (NsInitGroup = {}));
let InitGroupCommand = class InitGroupCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            const { args, hooks: runtimeHook } = ctx.getArgs();
            const hooks = ctx.getHooks();
            const result = yield hooks.initGroup.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const { graphData, commandService } = handlerArgs;
                const graph = yield ctx.getX6Graph();
                const { nodes } = graphData;
                const groupMap = {};
                nodes.forEach(node => {
                    const { id, group } = node;
                    if (group) {
                        if (groupMap[group]) {
                            groupMap[group].push(id);
                        }
                        else {
                            groupMap[group] = [id];
                        }
                    }
                });
                Object.keys(groupMap).forEach((groupId) => __awaiter(this, void 0, void 0, function* () {
                    const groupNode = graph.getCellById(groupId);
                    const groupData = groupNode.getData();
                    const childrenIds = groupMap[groupId] || [];
                    // 更新props
                    groupNode.prop('isGroup', true);
                    groupNode.setData(Object.assign(Object.assign({}, groupData), { isGroup: true, groupChildren: childrenIds }));
                    childrenIds.forEach(childId => {
                        const child = graph.getCellById(childId);
                        groupNode.embed(child);
                    });
                    // Group置于底层
                    groupNode.toBack();
                    // collapse
                    const { isCollapsed, groupCollapsedSize } = groupData;
                    if (isCollapsed) {
                        const collapsedSize = handlerArgs.collapsedSize || groupCollapsedSize || XFLOW_GROUP_DEFAULT_COLLAPSED_SIZE;
                        yield commandService.executeCommand(XFlowGroupCommands.COLLAPSE_GROUP.id, {
                            collapsedSize,
                            isCollapsed: true,
                            nodeId: groupNode.id,
                        });
                    }
                }));
                return {};
            }), runtimeHook);
            ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            if (this.isUndoable()) {
                ctx.undo();
            }
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.isUndoable()) {
                yield this.execute();
            }
            return this;
        });
    }
    isUndoable() {
        const ctx = this.contextProvider();
        return ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], InitGroupCommand.prototype, "contextProvider", void 0);
InitGroupCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsInitGroup.command.id },
    })
    /** 创建节点命令 */
], InitGroupCommand);
export { InitGroupCommand };
//# sourceMappingURL=group-init.js.map